import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import AuthShell from "../components/AuthShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function RedefinirSenha() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("As senhas não coincidem");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      toast.success("Senha redefinida com sucesso!");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Redefinir senha"
      subtitle="Escolha uma nova senha para acessar sua conta."
      footer={
        <Link to="/login" className="text-emerald-400 hover:text-emerald-300 font-medium" data-testid="link-voltar-login">
          Voltar para o login
        </Link>
      }
    >
      {done ? (
        <div className="text-center space-y-3" data-testid="reset-success">
          <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto" />
          <p className="text-sm text-slate-300">Senha alterada! Redirecionando para o login...</p>
        </div>
      ) : !token ? (
        <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 text-sm text-red-300" data-testid="reset-no-token">
          Link inválido. Solicite uma nova redefinição de senha.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 text-sm text-red-300" data-testid="reset-error">
              {error}
            </div>
          )}
          <div className="space-y-1.5">
            <Label htmlFor="password" className="text-slate-300">Nova senha</Label>
            <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mínimo 6 caracteres"
              data-testid="reset-password-input"
              className="bg-slate-800/60 border-slate-700 text-slate-100 placeholder:text-slate-500 focus-visible:ring-2 focus-visible:ring-emerald-500" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="confirm" className="text-slate-300">Confirmar nova senha</Label>
            <Input id="confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Repita a senha"
              data-testid="reset-confirm-input"
              className="bg-slate-800/60 border-slate-700 text-slate-100 placeholder:text-slate-500 focus-visible:ring-2 focus-visible:ring-emerald-500" />
          </div>
          <Button type="submit" disabled={loading} data-testid="reset-submit-button"
            className="w-full bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold h-11 transition-colors duration-150">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar nova senha"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
